 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import React from 'react'
import {Link} from 'react-router-dom'
import graphql from 'babel-plugin-relay/macro'
import Row from '../../../../components/Row/Row'
import {useFragment} from 'react-relay'
import plural from '../../../../utils/plural'






const OrgTeamsRow = (props) => {
  const {teamRef} = props
  const team = useFragment(
    graphql`
      fragment OrgTeamsRow_team on Team {
        id
        name
        teamMembers {
          id
          isLead
          isOrgAdmin
          isSelf
          email
        }
      }
    `,
    teamRef
  )
  const {id: teamId, teamMembers, name} = team
  const teamMembersCount = teamMembers.length
  const teamLeadEmail = _nullishCoalesce(_optionalChain([teamMembers, 'access', _ => _.find, 'call', _2 => _2((member) => member.isLead), 'optionalAccess', _3 => _3.email]), () => ( ''))
  const isViewerTeamLead = teamMembers.some(
    (member) => member.isSelf && (member.isLead || member.isOrgAdmin)
  )
  return (
    React.createElement(Row, null
      , React.createElement('div', { className: "flex w-full flex-col px-4 py-1"    ,}
        , React.createElement('div', { className: "text-gray-700 text-lg font-bold"  ,}, name)
        , React.createElement('div', { className: "flex items-center justify-between"  ,}
          , React.createElement('div', { className: "text-gray-600",}
            , `${teamMembersCount} ${plural(teamMembersCount, 'member')}`
            , isViewerTeamLead && (
              React.createElement(React.Fragment, null
                , React.createElement('span', { className: "mx-2",}, "•")
                , React.createElement(Link, {
                  to: `/team/${teamId}/settings`,
                  className: "cursor-pointer font-bold text-sky-500 hover:underline"   ,}

                  , 'Manage Team'
                )
              )
            )
          )

          , React.createElement('a', {
            href: `mailto:${teamLeadEmail}`,
            target: "_blank",
            title: "Email",
            className: "text-gray-600 hover:underline" ,
            rel: "noreferrer",}

            , `${teamLeadEmail} ${isViewerTeamLead ? '(You)' : ''}`
          )
        )
      )
    )
  )
}

export default OrgTeamsRow
